import React, { JSX } from 'react';

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { sanitize } from '@ibe/services';
import { ApiExtraService, ApiExtraUnit, ApiItemType, ApiUnitRate } from '@ibe/api';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';

import getIconForItemTye from '../Base/getItemForItemType';
import SummaryTabs from '../Base/SummaryTabs';
import SummaryItem from '../../Components/Cart/SummaryItem/SummaryItem';
import Dates from '../Dates';
import fallback from '../../../_Translations/generated/summary.en.t.json';
import Keys from '../../../_Translations/generated/summary.en.t.json.keys';
import useTranslation from '../../../ISO/Hooks//useTranslation';

const Summary = (props: BookedItemComponentProps): JSX.Element => {
  const {
    item,
    isOpen,
    showInfo,
    showTraveler,
    travelerId,
    booking,
    onDelete,
    order,
    customPriceModifier,
    showNumberOfPerson,
    useNameForDescription,
    showPricePlusMinus
  } = props;

  const icon = getIconForItemTye(item.itemType);
  const { t } = useTranslation('summary', fallback, Keys);

  const unitRate = booking.items.find(it => it.id === item.idParent) as ApiUnitRate;
  const extraUnit = booking.items.find(it => it.id === unitRate.idParent) as ApiExtraUnit;
  const extraService = booking.items.find(it => it.id === extraUnit.idParent) as ApiExtraService;

  const numberOfPersonLabel = showNumberOfPerson
    ? t(Keys.numberOfPerson, {
        count: Object.keys(item.priceByPersonId).length,
        numberOfPerson: Object.keys(item.priceByPersonId).length
      })
    : '';

  const InfoTabContent = (): JSX.Element => {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: sanitize(extraService.name) }} />
        <div dangerouslySetInnerHTML={{ __html: sanitize(extraUnit.description) }} />
        {numberOfPersonLabel ? (
          <div dangerouslySetInnerHTML={{ __html: sanitize(numberOfPersonLabel) }} />
        ) : null}
        {unitRate.optionDescription && (
          <div dangerouslySetInnerHTML={{ __html: sanitize(unitRate.optionDescription) }} />
        )}
        {unitRate &&
          (extraService.subType === ApiItemType.EXTRA ||
            extraService.subType === ApiItemType.DINING) && <div>{unitRate.startTime}</div>}
      </>
    );
  };

  const customPrice = customPriceModifier && customPriceModifier(item, travelerId);
  return (
    <SummaryItem
      title={extraService.name || ''}
      price={customPrice || item.price}
      subtitle={item.itemType}
      description={useNameForDescription ? item.name : item.description}
      icon={<Icon icon={icon} />}
      dates={<Dates item={item} />}
      isOpen={isOpen}
      onDelete={onDelete}
      booking={booking}
      item={item}
      order={order?.Extra}
      numberOfPerson={numberOfPersonLabel}
      showPricePlusMinus={showPricePlusMinus}
    >
      {(showInfo || showTraveler) && (
        <SummaryTabs
          booking={booking}
          item={item}
          info={<InfoTabContent />}
          showInfo={showInfo}
          showTraveler={showTraveler}
        />
      )}
    </SummaryItem>
  );
};

export default Summary;
